import * as taskPotentialUsers from '../actions';
import { ActionType, getType } from 'typesafe-actions';
import { RemoteData, failure, pending, success } from '@devexperts/remote-data-ts';
import { RootAction } from 'actions/rootAction';

export type taskPotentialUsersAction = ActionType<typeof taskPotentialUsers>;

type PotentialUsersState = {
    [taskId: string]: RemoteData<string, boolean>;
};
const reducer = (state: PotentialUsersState = {}, action: RootAction): PotentialUsersState => {
    switch (action.type) {
        case getType(taskPotentialUsers.getTaskPotentialUsers):
            return {
                ...state,
                [action.payload.taskId]: pending,
            };

        case getType(taskPotentialUsers.getTaskPotentialUsersFailure):
            return {
                ...state,
                [action.requestPayload.taskId]: failure(action.error.message),
            };
        case getType(taskPotentialUsers.getTaskPotentialUsersSuccess):
            return {
                ...state,
                [action.requestPayload.taskId]: success(action.payload.canClaimTask),
            };
        default:
            return state;
    }
};
export default reducer;
